module.exports = __webpack_public_path__ + "static/media/img_cooperation.3c707a96.png";